const initialState =
{
	screenNumber : null,
	screenLimit  : 2,
	screenPeers  : null
};

const tpscreensdata = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_SCREEN_NUMBER':
		{
			const { screenNumber } = action.payload;

			return { ...state, screenNumber };
		}
		case 'SET_SCREEN_LIMIT':
		{
			const { screenLimit } = action.payload;

			return { ...state, screenLimit };
		}
		case 'SCREEN_PEERS':
		{
			const { screenPeers } = action.payload;

			// eslint-disable-next-line no-console
			console.log('screenPeers==', screenPeers);

			return { ...state, screenPeers };
		}
		case 'ADD_SCREEN_PEER':
		{
			const { screenPeer } = action.payload;

			const copyPeers = state.screenPeers;

			copyPeers.push(screenPeer);

			return { ...state, screenPeers: [ ...copyPeers ] };
		}
		case 'REMOVE_SCREEN_PEER':
		{
			const { peerId } = action.payload;

			const copyPeers = state.screenPeers;

			const index = copyPeers.findIndex((each) => each.id === peerId);

			if (index > -1)
			{
				copyPeers.splice(index, 1);
			}

			return { ...state, screenPeers: [ ...copyPeers ] };

		}
		case 'ADD_CRASH_PEERS':
		{
			const { crashPeers } = action.payload;

			const copyPeers = state.screenPeers;

			return { ...state, screenPeers: [ ...copyPeers, ...crashPeers ] };
		}
		case 'clear_screen':
		{
			return initialState;
		}
		default:
			return state;
	}
};

export default tpscreensdata;
